import React from 'react';
import {message, notification} from "antd";
import axios from "axios";


function SendOPT(customerNumber,clientCode,amountDue,otp,clientAPIkey,extId) {

    // var extId = "0x" + (new Date().getTime());
    // first request
    var data = {
        "transactionRequest": {
            "extTransactionId": extId,
            "clientCode": clientCode,
            "msisdn": customerNumber,
            "otp": otp,
            "amount": amountDue,
            "checksum": '',
            "currency": "maloti",
            "otpMedium": "sms",
            "redirectUrl": ""

        }
    };
    let headersList = {
      "accept": "*/*",
      "Content-Type": "application/json",
      'Authorization': clientAPIkey,
      }
    let reqOptions = {
      url: `${process.env.REACT_APP_BASE_URL}cpaypayments/getchecksum`,
      method: "POST",
      headers: headersList,
      data: JSON.stringify(data),
    }
        
     axios.request(reqOptions).then(function (response) {
        var   data2 = {
            "transactionRequest": {
                "extTransactionId": extId,
                "clientCode": clientCode,
                "msisdn": customerNumber,
                "otp": otp,
                "amount": amountDue,
                "checksum": response.data,
                "currency": "maloti",
                "otpMedium": "sms",
                "redirectUrl": "",
            }
          };
            let reqOptions = {
            url: `${process.env.REACT_APP_BASE_URL}cpaypayments/confirm`,
            method: "POST",
            headers: headersList,
            data: JSON.stringify(data2),
                }  
            axios.request(reqOptions).then(function (response) {
            message.success("Payment successfully made");
            
            //openNotificationWithIcon("success", "Success", "M"+data2.transactionRequest.amount+" Payment successful. Pleasure doing business with you!");
            }).catch((error) => {
              message.error(error.message);
              //openNotificationWithIcon("error", "Error", error.response.data??error.message);
            })   

            }).catch((error) => {
              message.error(error.message);
              
              //openNotificationWithIcon("error", "Error", error.response.data??error.message);
            })  
}

export default SendOPT